import React, { createContext, useContext } from "react";
const ThemeOptionsContext = createContext({});
export function useThemeOptions() {
    return useContext(ThemeOptionsContext);
}
export default function ThemeOptionProvider({ children, ...props }) {
    return React.createElement(ThemeOptionsContext.Provider, { value: props }, children);
}
